import { PageRef } from 'providers/page-ref';

export enum ProgramSettingsTab {
  Training = 'training',
  Nutrition = 'nutrition',
}

export type ProgramSettingsPageParams = {
  tab?: ProgramSettingsTab;
};

export const IProgramSettingsPage: PageRef<ProgramSettingsPageParams, void> = {
  pageName: 'ProgramSettingsPage',
} as PageRef<ProgramSettingsPageParams, void>;
